import { Pipe, PipeTransform } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Pipe({
  name: 'shared'
})
export class SharedPipe implements PipeTransform {
  constructor(private toastr: ToastrService){}
  // transform(value: any, ...args: any[]): any {
  //   return null;
  // }
  transform(value: any, args: any[]): any {
    console.log('pipe Value =',value)
    console.log('Args Value =',args)
    if(!args){
      return value;
    }
    console.log(value)
    return value.filter((val:any)=>{
      let rVal= (val.rateCode.toLocaleLowerCase().includes(args) || val.echotoken.toLocaleLowerCase().includes(args));
      console.log('Shared pipe for search = ',rVal)
      return rVal;
    })
    
  }
}